module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg18.e3b333fe.jpg";